<style scoped>
    table {
        font-size: 14px;
    }
</style>
<template>
    <div>
        <audio src="assets/beep.wav" autostart="false" ref="soundbeep"></audio>
        <audio src="assets/error.wav" autostart="false" ref="sounderror"></audio>


        <div class="row well well-sm" style="border-bottom:1px solid gray">
            <div class="col-md-6 col-sm-6 ">
                <div v-if="Bag.patientId">
                    <a class="btn btn-link" style="padding:0px" @click="navigateToPatient">
                        <h3 class="text-info" style="margin-top:-5px;margin-bottom:2px">{{Bag.firstName}} {{Bag.middleName}} {{Bag.lastName}}</h3>
                    </a>
                    <table>
                        <tr><td><small><strong>Dob :</strong></small></td><td>{{FormatDate(Bag.dob)}}</td></tr>
                        <tr><td><small><strong>Nhs Id :</strong></small></td><td>{{Bag.nhsNumber}}</td></tr>
                        <tr>
                            <td><small><strong>Address :</strong></small></td>
                            <td>
                                <small>
                                    <span>{{Bag.addressLine}}       </span>
                                    <span>{{Bag.postCode}}      </span>
                                </small>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="col-md-4 col-md-offset-2 col-sm-6 ">
                <div class="col-md-8 col-sm-8 pull-right">
                    <input ref="aggCodeInput" v-if="addingAggCode" class="form-control pull-right" style="height:36px;width:100%" placeholder="Scan / Enter Aggregated Code" @keydown="AggCodeKeyDown" v-model="enteredAggCode" />
                    <a v-if="!addingAggCode && !this.Bag.aggregatedCode" class="btn btn-sm btn-default" style="width:100%" @click="startAggCode"> Add Aggregated Code</a>
                    <a v-if="this.Bag.aggregatedCode" class="btn btn-sm btn-default" style="width:100%">{{this.Bag.aggregatedCode}}</a>
                </div>
                <div style="height:100%;display: inline-block;vertical-align:bottom;float: none;"  v-if="Bag.patientId">
                    <a class="btn btn-sm btn-default" style="margin-right:10px" @click="EditPatient">Edit Patient</a>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div style="margin:10px" v-if="Bag.isRemoved">
                    <a class="btn btn-sm btn-danger" style="margin-right:10px">
                        <i class="fa fa-trash"></i>
                        <span style="margin-left:5px">Bag Removed</span>
                    </a>
                </div>
                <div style="margin:10px" v-if="!Bag.isRemoved">
                    <a class="btn btn-sm btn-danger" v-if="this.Items.length == 0"
                       @click.prevent="DeleteBag" style="margin-right:10px">
                        <i class="fa fa-trash"></i>   <span style="margin-left:5px">Delete</span>
                    </a>
                    <a class="btn btn-sm btn-default" :class="{'btn-success': Bag.status=='Working'}" @click.prevent="SetBagStatus(10)">
                        <i class="fa fa-refresh"></i>   <span style="margin-left:5px">Working</span>
                    </a>
                    <span v-if="Items.length > 0 && Bag.bagStatus==10">
                        <i class="fa fa-chevron-right"></i>
                        <a class="btn btn-primary btn-sm" @click.prevent="SetBagStatus(20)">
                            <i class="fa fa-shopping-bag"></i>   <span style="margin-left:5px">Ready for Delivery</span>
                        </a>
                    </span>
                    <span v-if="Items.length > 0 && Bag.bagStatus==20">
                        <i class="fa fa-chevron-right"></i>
                        <a class="btn btn-success btn-sm">
                            <i class="fa fa-shopping-bag"></i>   <span style="margin-left:5px">Completed </span>
                        </a>

                        <i class="fa fa-chevron-right"></i>
                        <a class="btn btn-primary btn-sm" @click.prevent="SetBagStatus(30)">
                            <i class="fa fa-paper-plane"></i>   <span style="margin-left:5px">Mark Delivered</span>
                        </a>
                    </span>
                    <span v-if="Items.length > 0 && Bag.bagStatus==30">
                        <i class="fa fa-chevron-right"></i>
                        <a class="btn btn-default btn-sm" href="">
                            <i class="fa fa-shopping-bag"></i>   <span style="margin-left:5px">Completed </span>
                        </a>

                        <i class="fa fa-chevron-right"></i>
                        <a class="btn btn-success btn-sm" @click.prevent="SetBagStatus(30)">
                            <i class="fa fa-paper-plane"></i>   <span style="margin-left:5px">Delivered</span>
                        </a>
                    </span>
                </div>
            </div>
            <div class="col-md-6">
                <a v-if="ScannerStatus==0" class="btn btn-sm btn-primary pull-right" style="margin:5px" @click="RefreshItems">
                    <i class="fa fa-refresh"></i>
                    Reload
                </a>
                <a class="btn btn-sm btn-info pull-right" style="margin:5px" @click="CalibrateScanner"><i class="fa fa-cog fa-1x"></i> &nbsp;Configure</a>

                <a v-if="ScannerStatus==0 && DocumentHasFocus" class="btn btn-sm btn-info pull-right" style="margin:5px">
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                    Reader Active
                </a>
                <a v-if="ScannerStatus==0 && !DocumentHasFocus" class="btn btn-sm btn-warning pull-right" style="margin:5px">
                    <i class="fa fa-exclamation-triangle"></i>
                    Reader Inactive
                </a>
                <a v-if="ScannerStatus==1" class="btn btn-sm btn-danger pull-right" style="margin:5px">
                    <i class="fa fa-exclamation-triangle faa-pulse"></i>
                    Duplicate Item
                </a>

            </div>
        </div>
        <div class="row ">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <div class="panel-title">Bag Items</div>
                    </div>
                    <div class="panel-body" style="min-height:400px">
                        <table class="table table-striped table-hover" v-if="!Bag.isRemoved">
                            <thead>
                                <tr>
                                    <th>Added Time</th>
                                    <th>Status</th>
                                    <th>GTIN</th>
                                    <th>Serial</th>
                                    <th>DrugName</th>
                                    <th>Batch</th>
                                    <th>Expiry</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item,index) of Items">
                                    <tr>
                                        <td>
                                            <span v-if="item.isRemoved" class="text-danger"><i class="fa fa-trash"></i> Removed</span>
                                            <span v-else>{{FormatTime(item.whenCreated)}}</span>
                                        </td>

                                        <td>
                                            <TooltipControl :title="ItemStatusMessage(item)">
                                                <i v-if="item.status == 10 ||
                                                item.status == 50 ||
                                                item.status == 80 ||
                                                item.status == 110 ||
                                                item.status == 140"
                                                   class="fa fa-refresh fa-spin"></i>



                                                {{GetFmdStatusDescription(item.status)}}
                                            </TooltipControl>
                                        </td>
                                        <td>{{item.gtin}}</td>
                                        <td>{{item.sn}}</td>
                                        <td>{{item.drugName}}</td>
                                        <td>{{item.batchNumber }}</td>
                                        <td>{{FormatFmdDate(item.expiryDate)}}</td>
                                        <td>
                                            <a class="text-warning" v-if="!item.isRemoved && item.status!=60" href="#" @click.prevent="DeleteItem(index)"
                                               data-toggle="tooltip" data-placement="top" title="Remove Item"><i class="fa fa-trash fa-1x"></i></a>
                                            <a class="text-primary" v-if="!item.isRemoved && (item.status==60 || item.status==100)" href="#" @click.prevent="UndoDecommision(index)"
                                               data-toggle="tooltip" data-placement="top" title="Undo decommision">
                                                <i class="fa fa-undo fa-1x"></i>
                                            </a>
                                        </td>

                                    </tr>
                                </template>
                                <!--<tr v-if="!EntryController">
                                    <td colspan="10">
                                        <input class="form-control" placeholder="Scan FMD Code - Focus here"></input>
                                    </td>
                                </tr>-->

                                <tr v-if="EntryController">
                                    <td colspan="10">
                                        <div class="col-sm-3"><forminput v-bind:controller="EntryController.gtin"></forminput></div>
                                        <div class="col-sm-3"><forminput v-bind:controller="EntryController.sn"></forminput></div>
                                        <div class="col-sm-3"><forminput v-bind:controller="EntryController.batch"></forminput></div>
                                        <div class="col-sm-3"><forminput v-bind:controller="EntryController.expiry"></forminput></div>
                                    </td>
                                </tr>
                                <tr v-if="EntryController">
                                    <td colspan="10">
                                        <a v-if="!EntryController.hasError" class="btn btn-primary" @click="AddManualEntry" style="width:100px">Add</a>
                                        <a class="btn btn-warning" @click="StopManualEntry" style="width:100px">Cancel</a>
                                    </td>
                                </tr>
                                <tr v-if="!EntryController">
                                    <td colspan="100"><a class="btn btn-primary" @click="StartManualEntry">Add Manually</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" ref="myModal" role="dialog">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">Aggregated Code</h4>
                    </div>
                    <div class="modal-body">
                        Scan the aggregated barcode for this bag.
                        <br /><br />
                        <input id="aggCodeDialogInput" class="form-control pull-right" style="height:36px;width:100%" placeholder="Scan / Enter Aggregated Code" @keydown="AggCodeKeyDown" v-model="enteredAggCode" />
                        <br />
                        <br />
                    </div>
                    <div class="modal-footer" >
                        <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">Close</button>
                        <button type="button" v-if="Bag.patientId" class="btn btn-warning btn-sm" data-dismiss="modal" @click="disableAggregatedCode">Dont Show Again</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import FmdDal from "../../../scripts/FmdDal";
    import Formatter from "../../corecontrols/formatters/Formatter";
    import PatientSearchBox from "../../appcontrols/PatientSearchBox/PatientSearchBox.scp.html"
    import ManualFmdEntryController from "./ManualFmdEntryController"
    import forminput from "../../corecontrols/forminput/forminput.scp.html"
    import toastr from "toastr";
    import $ from "jquery"
    import { setTimeout } from "timers";
    import moment from 'moment';
    import Scanner from './Scanner';
    import { BagItemDto, FmdCode } from "../../../dto/FMD/Models";

    import TooltipControl from './../../corecontrols/tooltipcontrol/tooltipcontrol.scp.html';

    export default {
        props: ['bagId'],
        watch: {
            '$route'(to, from) {
                //on route change re run: onCreated
                console.log("[BagManagement]" , to , from)
                if (to.path == '/fmd/bag/') {
                    alert("RErendering?")
                    this.$forceUpdate();
                    this.Bag = {};
                    this.aggregatedCode = ""
                    this.OpenAggregatedCode();
                }
            }
        },
        components: {
            PatientSearchBox
        },
        data: function () {
            return {
                IsNew: false,
                Bag: {},
                Items: [],
                ScannerStatus: 0,
                EntryController: null,
                FmdScanner: new Scanner(),
                DocumentHasFocus: true,
                Dal: {},
                enteredAggCode: "",
                addingAggCode: false,
                interval : -1
            }
        },
        created() {
            this.onCreated();
        },
        mounted() {
            console.log("[BagManagement]" + "mounting bag management")

            if (this.bagId) {

                console.log("[BagManagement]" + "Trying to get Bag : " + this.bagId)
                this.Dal.GetBag(this.bagId).then(b => {
                    this.Bag = b;
                    this.Items = b.patientBagMeds || [];
                    if (!this.Bag.isRemoved) {
                        console.log("[BagManagement]" + "Started Keyboard scanner - With Patient")
                        document.addEventListener("keydown", this.ProcessKeyboardDown)
                    }
                    if (!this.Bag.isRemoved && !this.Bag.aggregatedCode) {
                        var disabled = localStorage.getItem("AggCodeDisabled");
                        if (!disabled && disabled != "false") {
                            //this.scanningAggCode = true;
                            this.OpenAggregatedCode()
                        }
                    }
                });
                console.log("[BagManagement]" + "Setting interval")
                this.interval = setInterval(() => {
                    console.log("[BagManagement]" + "Handler ", this.bagId)
                }, 3000)
            }
            else {
                // There is a new bag without patient - The bag has not been created 
                console.log("[BagManagement]" + "Started Keyboard scanner - No Patient")
                document.addEventListener("keydown", this.ProcessKeyboardDown)
                this.OpenAggregatedCode();
            }

            $(this.$refs.myModal).on('shown.bs.modal', function () {
                $('#aggCodeDialogInput').focus();
            })

            var that = this;
            $(this.$refs.myModal).on('hidden.bs.modal', function () {
                // no bag has been loaded or created go back
                if (!that.Bag.id) {

                    that.log("Goto dashboard", that.Bag)
                    that.$router.go(-1)
                    that.$router.push({ path: '/fmd/bags' }) 
                }


              
            })

            window.onfocus = this.onFocus;
            window.onblur = this.onBlur;

        },
        //beforeRouteUpdate(to) {
        //    this.name = to.params.name
        //},
        destroyed() {
            console.log("[BagManagement]" + "destroyed - Removing event handlers")
            clearInterval(this.interval)
            document.removeEventListener("keydown", this.ProcessKeyboardDown)
        },
        beforeDestroy() {
            console.log("[BagManagement]" + "before destroyed - Removing event handlers")
            clearInterval(this.interval)
            document.removeEventListener("keydown", this.ProcessKeyboardDown)
        },
        methods: {
            log(msg, ...objs) {
                if(objs)
                    console.log("[BagManagement]: " + msg, objs)
                else
                    console.log("[BagManagement]: " + msg)
            },
            onCreated() {
                console.log("[BagManagement]" + "Running On Created")
                var that = this;
                this.Bag = {}
                this.IsNew = false
                this.Bag = {}
                this.Items = []
                this.ScannerStatus = 0
                this.EntryController = null
                this.FmdScanner = new Scanner()
                this.DocumentHasFocus = true
                this.Dal = {}
                this.enteredAggCode = ""
                this.addingAggCode = false

                this.Dal = new FmdDal(this.$root.CurrentUnitId, this.$root.UiSession);

                this.$bus.$on('FMD.BagItemAdded', ($event) => {
                    console.log("[BagManagement]" + "Bagmanagement FMD.BagItemAdded " + $event.bagId)
                    that.CheckNewItem($event.bagItemId)
                })
                this.$bus.$on('FMD.BagItemUpdated', ($event) => {
                    console.log("[BagManagement]" + "Bagmanagement FMD.BagItemAdded " + $event.bagId)
                    that.UpdateExistingItem($event.bagId, $event.bagItemId)
                })
            },
            navigateToPatient() {
                this.$router.push({ path: '/fmd/Patient/' + this.Bag.patientId });
            },
            AggCodeKeyDown(e) {
                console.log("[BagManagement]" + "aaa",e)
                if (e.key == "Enter") {
                    this.addingAggCode = false;
                    if (this.enteredAggCode) {
                        this.Bag.aggregatedCode = this.enteredAggCode;
                        if (this.bagId) {
                            // Bag already created
                            this.Dal.UpdateBag(this.Bag).catch(e => {
                                var message = "Could not save Agg Code <br/>" + e.response.data
                                toastr.error(message)
                                this.Bag.aggregatedCode = "";
                            })
                        }
                        else {
                            //Creat enew bag
                            this.Dal.CreateBagWithAggCode(this.enteredAggCode)
                                .then(b => {
                                    this.Bag = b;
                                    $(this.$refs.myModal).modal('hide');
                                    console.log("[BagManagement]" + "Created bag", b)
                                    //this.$router.push({ path: '/fmd/bag/' + b.id })
                                    var d = new Date();
                                    var n = d.getTime();
                                    this.$router.push({ name: 'fmd.managebag', params: { bagId: b.id, key: n} })

                                
                                })
                                .catch(e => {
                                var message = "Could not save Agg Code <br/>" + e.response.data
                                toastr.error(message)
                                this.Bag.aggregatedCode = "";
                            })
                        }
                    }
                }
                if ((e.key.length > 1 && e.key!="Backspace") || e.key == "$") {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            startAggCode() {
                this.addingAggCode = true;
                this.$nextTick(() => {
                    this.$refs.aggCodeInput.focus();
                })
            },
            disableAggregatedCode() {
                localStorage.setItem("AggCodeDisabled", true);
            },
            OpenAggregatedCode() {
                $(this.$refs.myModal).modal('show');
            },
            CalibrateScanner() {
                this.$router.push({ name:"fmd.scannercalibrate"})
            },
            EditPatient() {
                this.$router.push({ path: '/fmd/patient/edit/' + this.Bag.patientId });
            },
            onBlur() {
                this.DocumentHasFocus = false;
            },
            onFocus() {
                this.DocumentHasFocus = true;
            },
            //CheckFocus() {
            //    this.DocumentHasFocus = document.hasFocus();
            //    setTimeout(this.CheckFocus, 5000);
            //},
            RefreshItems() {

                return this.Dal.GetBag(this.bagId).then(b => {
                    this.Items = b.patientBagMeds || [];
                    return true
                });
            },
            ProcessKeyboardDown(e) {
                console.log("[BagManagement]" + "ProcessKeyDown", e)
                if (e.srcElement.localName == "input") {
                    return;
                }

                var st = this.FmdScanner.AddKeyDown(e.key, e.keyCode)
                if (st >= 0) {
                    console.log("[BagManagement]" + "PReveting propogation : " + st)
                    e.preventDefault();
                    e.stopPropagation();
                }
                if (st == 1) {
                    var item = this.FmdScanner.FmdCode;
                    console.log("[BagManagement]" + "Item Detected", item)
                    this.AddNewItem(item);
                }
            },
            ItemStatusMessage(item) {
                var text = "";
                if (item.packReason) {
                    text += "Pack:   " + item.packReason + "-" + item.packState + "\n";
                }
                if (item.returnCode) {
                    text += "Return:   " + item.returnCode + (item.returnCodeDesc ? "-" + item.returnCodeDesc : "") + "\n";
                }
                if (item.interMarket) {
                    text += "[International]" + "\n";
                }

                return text;

                //"<small><strong>Pack:</strong> " + item.packReason + "-" + item.packState + "</small><br/>"+
                //"<small><strong>Pack:</strong> " + item.packReason + "-" + item.packState + "</small><br/>"+
                //"<small><strong>Pack:</strong> " + item.packReason + "-" + item.packState + "</small><br/>"+

                //    //<small>returnCode: {{ item.returnCode }}</small>
                //    //<small>returnDesc: {{ item.returnDesc }}</small>
                //"<small>[International]</small>"
            },
            FormatFmdDate(ex) {
                var dtString = ex;
                if (ex != null && ex.length == 6  && ex.substring(4, 6) == "00") {
                    dtString = ex.substring(0, 4) + "01";
                }
                return moment(dtString, "YYMMDD").format("MMM/YYYY");
                //return moment(dt)
                //console.log("[BagManagement]" + ex, dt);
                //return Formatter.FormatDate(dt);
            },
            FormatTime(dt) {
                return Formatter.FormatDateTime(dt)
            },
            FormatDate(dt) {
                return Formatter.FormatDate(dt)
            },
            StartManualEntry() {
                document.removeEventListener("keydown", this.ProcessKeyboardDown)
                this.EntryController = new ManualFmdEntryController();
                this.EntryController.validate();
            },
            StopManualEntry() {
                this.EntryController = null;
                document.addEventListener("keydown", this.ProcessKeyboardDown)
            },
            AddManualEntry() {
                var item = new FmdCode();
                if (this.EntryController) {
                    item.gtin = this.EntryController.gtin.value;
                    item.batchNumber = this.EntryController.batch.value;
                    item.sn = this.EntryController.sn.value;
                    item.expiryDate = this.EntryController.expiry.value;

                    this.AddNewItem(item).then(() => {
                        this.StopManualEntry();
                    });
                }
            },
            AddNewItem(item) {
                for (var i of this.Items) {
                    if (i.sn == item.sn
                        && (i.sn && i.sn != "")
                        && (item.sn && item.sn != "")) {
                        this.PlayError();
                        this.ScannerStatus = 1;
                        setTimeout(() => this.ScannerStatus = 0, 1000);
                        return;
                    }
                }
                var bagItem = new BagItemDto();
                bagItem.bagId = this.Bag.bagId;
                bagItem.batchNumber = item.batchNumber;
                bagItem.sn = item.sn;
                bagItem.expiryDate = item.expiryDate;
                bagItem.gtin = item.gtin;
                bagItem.status = 0;
                this.Items.push(bagItem);
                return this.Dal.SaveBagItem(this.Bag, item).then(bi => {
                    var index = -1;
                    for (var i in this.Items) {
                        if (this.Items[i].sn == bi.sn) {
                            this.Items[i].id = bi.id;
                            index = i;
                            break;
                        }
                    }
                    this.Items.splice(index, 1, bi);
                    this.SetReloadTimer();
                }).catch(e => {
                    console.log("[BagManagement]" + e.response)
                    toastr.error("Cannot Add Item \n " + e.response.data)
                    var index = -1;
                    for (var i in this.Items) {
                        if (this.Items[i].sn == bagItem.sn) {
                            index = i;
                            break;
                        }
                    }
                    if (index >= 0) {
                        this.Items.splice(index, 1);
                    }
                })
            },
            PlayBeep() {
                var sound = this.$refs.soundbeep;
                sound.play();
            },
            PlayError() {
                var sound = this.$refs.sounderror;
                sound.play();
            },
            AddItem(content) {
                var item = {
                    bagId: this.bagId,
                    createdDate: new Date(),
                    itemCode: content,
                    status: 'Created',
                };
                this.Items.unshift(item)
                this.Dal.CreateBagItem(this.bagId, content).then(i => {
                    item.bagItemId = i.bagItemId;
                    item.status = "Added";
                    this.SetReloadTimer();
                })


            },
            DeleteBag() {
                this.Dal.DeleteBag(this.bagId, this.Bag.patientId).then(() => {
                    this.Dal.GetBag(this.bagId).then(b => {
                        this.Bag = b;
                        this.Items = b.patientBagMeds || [];
                        //this.Patient = b.patient;
                    });
                })
            },
            SetBagStatus(status) {
                this.Dal.UpdateBagStatus(this.bagId, status).then(b => {
                    this.Bag = b;
                    this.Items = b.patientBagMeds || [];
                    this.SetReloadTimer();
                })
            },
            UndoDecommision(index) {
                var item = this.Items[index];
                this.Dal.UndoDecommision(this.Bag.id, item.id).then(bi => {
                    var ind = -1;
                    for (var i in this.Items) {
                        if (this.Items[i].id == bi.id) {
                            index = i;
                            break;
                        }
                    }
                    this.Items.splice(index, 1, bi);
                    this.SetReloadTimer();
                })

            },
            DeleteItem(index) {
                this.Items[index].isRemoved = true;
                var item = this.Items[index];
                this.Dal.SaveBagItem(this.Bag, item).then(bi => {
                    var index = -1;
                    for (var i in this.Items) {
                        if (this.Items[i].sn == bi.sn) {
                            index = i;
                            break;
                        }
                    }
                    this.Items.splice(index, 1, bi);
                    this.SetReloadTimer();
                })
            },
            CheckNewItem(bagItemId) {
                var that = this;
                this.Dal.GetBagItem(this.bagId, bagItemId).then(i => {
                    for (var item of that.Items) {
                        if (item.bagItemId == bagItemId) {
                            return;
                        }
                    }
                    that.Items.unshift(i)
                })
            },
            UpdateExistingItem(bagId, bagItemId) {
                var that = this;
                this.Dal.GetBagItem(this.bagId, bagItemId).then(i => {
                    for (var item of that.Items) {
                        if (item.bagItemId == bagItemId) {
                            item.status = i.status;
                        }
                    }
                    this.SetReloadTimer();
                })
            },
            SetReloadTimer() {
                this.refreshTimer = setTimeout(this.RefreshDataForAnyPendingItems, 5000);
            },
            RefreshDataForAnyPendingItems() {
                console.log("[BagManagement]" + "Running RefreshDataForAnyPendingItems...")
                this.RefreshItems().then(b => {
                    var refreshRequired = false;
                    for (var item of this.Items) {
                        if (item.status == 10 ||
                            item.status == 50 ||
                            item.status == 80 ||
                            item.status == 110 ||
                            item.status == 140) {
                            refreshRequired = true;
                            break;
                        }
                    }
                    if (refreshRequired) {
                        this.refreshTimer = setTimeout(this.RefreshDataForAnyPendingItems, 5000)
                    }
                    else {
                        console.log("[BagManagement]" + "RefreshDataForAnyPendingItems Refresh not required!")
                    }
                })
            },
            GetFmdStatusDescription(status) {
                switch (status) {
                    case 0: return "Draft"
                    case 5: return "FMD Manual"
                    case 10: return "Pending"
                    case 20: return "FMD Not Applicable"
                    case 30: return "FMD Success"
                    case 40: return "FMD Check Failed"
                    case 50: return "Decommission Pending"
                    case 60: return "Decommission Success"
                    case 70: return "Decommission Failure"
                    case 80: return "Undo Decomission Pending"
                    case 90: return "Undo Decomission Success"
                    case 100: return "Undo Decomission Failure"
                    case 110: return "Decommission Pending"
                    case 120: return "Decommission Success"
                    case 130: return "Decommission Failure"
                    case 140: return "Undo Decomission Pending"
                    case 150: return "Undo Decomission Success"
                    case 160: return "Undo Decomission Failure"
                    default: return "Unknown"
                }
            },
        },
        components: {
            Formatter,
            forminput,
            TooltipControl
        }
    }
</script>




// WEBPACK FOOTER //
// BagManagementCore.scp.html?17406648